<template lang="html">
    <div class="page-container">
        <div class="page-container__header"> 
            <h1 class="header-1 page-container__title">Adaugă credite</h1>
        </div>
        <div class="page-container__body page-container__body--white">
            <div class="topup">
                <h3 class="heading-3 topup__title">Ce sumă dorești să adaugi?</h3>
                <div class="topup__arrowscroll-variants" v-arrowscroll>
                    <div class="topup__variants" v-dragscroll="!isMobile">
                        
                        <div v-for="value in sums"
                            :key="value"
                            class="topup__variant"
                            :class="{
                                'topup__variant__active': sum == value
                            }" @click="selectSum(value)">

                            {{value}} <img src="@/assets/images/icons/coins.svg" alt="">
                        </div>

                    </div>
                </div>
                <div class="topup__card">
                    <div class="topup__amount">
                        <span>
                            {{sum}} <img src="@/assets/images/icons/coins.svg" alt="">
                        </span>
                    </div>
                    <div @click="decrease"
                        :style="{cursor: sum <= 10 ? 'not-allowed' : 'pointer'}"
                        class="topup__arrow topup__arrow--decrease">
                        <i class="fas fa-chevron-left"></i>
                    </div>  
                    <div @click="increase"
                        :style="{cursor: sum >= 10000 ? 'not-allowed' : 'pointer'}"
                        class="topup__arrow topup__arrow--increase">
                        <i class="fas fa-chevron-right"></i>
                    </div>
                </div>

                <div class="topup__info" v-if="this.foreigner">
                    <span>1 EUR = 4 <img src="@/assets/images/icons/coins.svg" alt=""></span>
                    <small>Sumă minimă: 10 EUR</small>
                </div>
                <div class="topup__info" v-else>
                    <span>1 RON = 1 <img src="@/assets/images/icons/coins.svg" alt=""></span>
                    <small>Sumă minimă: 10 RON</small>
                </div>
                <div class="spacer"></div>
                <UiButton
                    name="Cumpara"
                    class="payment-button"
                    @click="pay" />
                <small class="topup__vat"> Preturile afisate sunt fara TVA.</small>
                <div class="spacer"></div>
            </div>   
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UiButton from '@/components/ui/Button'

export default {
    components: {
        UiButton
    },
    data() {
        return {
            sum: 300,
            sums: [ 50, 100, 300, 500, 999 ],
            foreigner: false
        };
    },
    computed: {
        ...mapGetters({
            user: 'user/user',
            isMobile: 'layout/isMobile'
        }),
    },
    watch:{
        "$store._modules.root.state.user.user.address"(newVal) {
            if (newVal && (newVal != undefined || newVal != null)) {
                this.foreigner = (newVal.country != "Romania");
            }
        },
    },
    methods: {
        ...mapActions({
            topup: 'payments/topup',
            billingDetailsModal: 'layout/billingDetailsModal'
        }),
        selectSum(value) {
            this.sum = value;
        },
        increase() {
            if(this.sum < 10000)
                this.sum += 10;

            if (this.sum > 10000) {
                this.sum = 10000;
            }
        },
        decrease() {
            if(this.sum > 10)
                this.sum -= 10;

            if (this.sum < 10) {
                this.sum = 10;
            }
        },
        pay() {
            if(localStorage.getItem('address') !== 'true'){
                this.billingDetailsModal(true);
                return;
            }

            this.$store.state.payments.modal.active = true;

            var data = {
                amount: this.sum
            };
            this.topup(data);
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "@/scss/pages/topup";
</style>

